import {
  NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST,
  NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_SUCCESS,
  NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_FAIL
} from '../../actions/ns/matchingConfig';

export const initialState = {
  riskIndicators: {
    isLoading: false,
    error: null,
    data: []
  }
};

function nsRiskIndicators(state = initialState, action) {
  switch (action.type) {
    case NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST:
      return {
        ...state,
        riskIndicators: {
          isLoading: true,
          data: [],
          error: null
        }
      };
    case NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_SUCCESS:
      return {
        ...initialState,
        riskIndicators: {
          isLoading: false,
          data: action.payload?.data,
          error: null
        }
      };
    case NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_FAIL:
      return {
        ...state,
        riskIndicators: {
          isLoading: false,
          data: [],
          error: action.payload
        }
      };
    default:
      return {
        ...state
      };
  }
}

export default nsRiskIndicators;
